export const siteConfig = {
  name: "DULORME LABS",
  legalName: "DULORME LABS™",
  domain: "dulormelabs.com",
  calendlyUrl: process.env.REACT_APP_CALENDLY_URL || "https://cal.com",
  logoUrl: process.env.REACT_APP_LOGO_URL || "",
  gaId: process.env.REACT_APP_GA_ID || "",
  metaPixelId: process.env.REACT_APP_META_PIXEL_ID || "",
  social: {
    instagram: "#",
    linkedin: "#",
    twitter: "#",
    facebook: "#",
  },
  nav: [
    { label: "Services", to: "/services" },
    { label: "Industries", to: "/industries" },
    { label: "About", to: "/about" },
    { label: "Work", to: "/work" },
    { label: "Contact", to: "/contact" },
  ],
};
